import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons/faExclamationTriangle';

import React from 'react';
import PropTypes from 'prop-types';

import styles from '../../styles.module.less';

const ConfigureNotAllowedWarning = ({ children }) => {
  return (
    <div className={styles.warning}>
      <div className={styles.icon}>
        <FontAwesomeIcon icon={faExclamationTriangle} />
      </div>
      <div className={styles['warning-text']}>{children}</div>
    </div>
  );
};

ConfigureNotAllowedWarning.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ConfigureNotAllowedWarning;
